// ════════════════════════════════════════════════════════════════════════════════════════════════════════════
//  «ESCRIBIR POR WHATSAPP» A BIANGO, EN EL «?» · LO ENCIENDE EL SERVIDOR                              (3-oct-2026)
// ════════════════════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: el 624 665 615 es también el WhatsApp de Biango, pero «ahora no hay WhatsApp hasta que no haga lo de Meta».
//  La fila está preparada en el «?» (utils/contactoBiango.jsx) y no sale hasta que el servidor lo diga: con
//  BIANGO_WHATSAPP_ACTIVO=1 en su .env, GET /api/config-cliente trae `biango_whatsapp` con el enlace (si no, null;
//  backend/services/whatsappBiango.js). hooks/useBranding lo apunta aquí al recibir esa respuesta, y el «?» lo lee al
//  pintarse (la cabecera se repinta con la marca). Sin hooks y sin React, a propósito: el «?» se carga de verdad en
//  decenas de guardias.
//  Solo se acepta un enlace wa.me con el número de Biango: cualquier otra cosa se queda en null y la fila no sale.
export const WHATSAPP_BIANGO = 'https://wa.me/34624665615'

let enlace = null

export function ponerWhatsappBiango(valor) {
  enlace = valor === WHATSAPP_BIANGO ? WHATSAPP_BIANGO : null
  return enlace
}

export function whatsappBiango() {
  return enlace
}
